import { render } from "./DocumentLabel.vue?vue&type=template&id=2b37e712&lang=pug"
import script from "./DocumentLabel.vue?vue&type=script&lang=ts"
export * from "./DocumentLabel.vue?vue&type=script&lang=ts"
script.render = render

export default script